import styled from 'styled-components'
import { layout } from 'styled-system'

import { Row } from 'Components/UI'

const Desktop = styled(Row).attrs({
  display: ['none', 'none', 'none', 'none', 'block'],
})`
  ${layout}
`

const Tablet = styled(Row).attrs({
  display: ['none', 'none', 'block', 'block', 'none'],
})`
  ${layout}
`

const Mobile = styled(Row).attrs({
  display: ['block', 'block', 'block', 'block', 'none'],
})`
  ${layout}
`

const MobileOnly = styled(Row).attrs({
  display: ['block', 'block', 'none'],
})`
  ${layout}
`

const NotMobileOnly = styled(Row).attrs({
  display: ['none', 'none', 'block'],
})`
  ${layout}
`

const View = {
  Desktop,
  Mobile,
  MobileOnly,
  NotMobileOnly,
  Tablet,
}

export default View
